export function resetSize(vm) {
  var img_width, img_height, bar_width, bar_height; // 图片的宽度、高度，移动条的宽度、高度

  var parentWidth = vm.$el.parentNode.offsetWidth || window.offsetWidth;
  var parentHeight = vm.$el.parentNode.offsetHeight || window.offsetHeight;

  if (vm.imgSize.width.indexOf("%") != -1) {
    img_width = (parseInt(this.imgSize.width) / 100) * parentWidth + "px";
  } else {
    img_width = this.imgSize.width;
  }

  if (vm.imgSize.height.indexOf("%") != -1) {
    img_height = (parseInt(this.imgSize.height) / 100) * parentHeight + "px";
  } else {
    img_height = this.imgSize.height;
  }

  if (vm.barSize.width.indexOf("%") != -1) {
    bar_width = (parseInt(this.barSize.width) / 100) * parentWidth + "px";
  } else {
    bar_width = this.barSize.width;
  }

  if (vm.barSize.height.indexOf("%") != -1) {
    bar_height = (parseInt(this.barSize.height) / 100) * parentHeight + "px";
  } else {
    bar_height = this.barSize.height;
  }

  return {
    imgWidth: img_width,
    imgHeight: img_height,
    barWidth: bar_width,
    barHeight: bar_height,
  };
}

export const _code_chars = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
export const _code_color1 = ["#fffff0", "#f0ffff", "#f0fff0", "#fff0f0"];
export const _code_color2 = [
  "#FF0033",
  "#006699",
  "#993366",
  "#FF9900",
  "#66CC66",
  "#FF33CC",
];
/**
 * 判断是否为移动端设备
 * @returns {Boolean} true=移动端，false=PC端
 */
export const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  // 匹配常见移动端设备的UA关键词
  const mobileKeywords = [
    "android",
    "iphone",
    "ipad",
    "ipod",
    "ios",
    "windows phone",
    "blackberry",
    "webos",
    "symbian",
    "micromessenger", // 微信内置浏览器
    "mobile",
    "phone",
    "tablet",
  ];
  // 排除平板（可选，如需区分平板和手机可单独处理）
  const isTablet =
    /ipad|tablet|playbook|silk/i.test(userAgent) && !/mobile/i.test(userAgent);
  if (isTablet) return false; // 平板按PC处理（可根据需求调整）

  return mobileKeywords.some((keyword) => userAgent.includes(keyword));
};

/**
 * 判断是否为PC端
 * @returns {Boolean} true=PC端，false=移动端
 */
export const isPc = () => !isMobile();

/**
 * 时间函数
 */
export const formatNativeTime = (timeStr) => {
  // 边界判断：避免无效时间报错
  if (!timeStr) return "暂无数据";

  const date = new Date(timeStr);
  // 校验时间是否有效
  if (isNaN(date.getTime())) return "无效时间";

  // 补 0 工具函数：个位数前面加 0
  const padZero = (num) => num.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1); // 月份 0-11，需 +1
  const day = padZero(date.getDate());
  const hours = padZero(date.getHours());
  const minutes = padZero(date.getMinutes());
  const seconds = padZero(date.getSeconds());

  // 拼接成最终格式（YYYY-MM-DD HH:mm:ss）
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
